import { useNotifier } from '@axl/accel-framework/components';
import { SchoolContentSectionType } from '@axl/accel-framework/models';
import { combineClasses } from '@axl/accel-framework/utils';
import { Button, Tooltip } from 'antd';
import { useLoc } from 'components';
import { observer } from 'mobx-react';
import React, { useCallback, useMemo } from 'react';
import { useInstance } from 'react-ioc';
import { FavoriteStore } from 'stores';
import styles from './FavoriteButton.module.scss';

type FavoriteButtonProps = {
    sectionType: SchoolContentSectionType;
    itemId: string;
    className?: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ sectionType, itemId, className }) => {
    const store = useInstance(FavoriteStore);
    const loc = useLoc();
    const [notify] = useNotifier();

    const isFavorite = useMemo(() => store.isFavorite(itemId), [store.items, itemId]);

    const title = useMemo(() => isFavorite
        // Убрать из избранного
        ? loc.word('Favorites.removeTitle', { default: 'Remove from favorites' })
        // Добавить в избранное
        : loc.word('Favorites.addTitle', { default: 'Add to favorites' }),
        [isFavorite]);

    const handleClick = useCallback(async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        const result = await store.toggle(sectionType, itemId);
        if (result != null && !result.success)
            notify(result);
    }, [sectionType, itemId]);

    if (!store.isEnabled || !itemId)
        return null;

    return <Tooltip title={title}>
        <Button type='text'
            size='small'
            aria-label={title}
            className={combineClasses(styles.favorite_button, isFavorite ? styles.active : undefined, className)}
            onClick={handleClick}>
            <span className={styles.icon}>{store.icon}</span>
        </Button>
    </Tooltip>;
}

export default observer(FavoriteButton);
